import React from 'react';
import OutputString from "./type/OutputString";
import OutputDate from "./type/OutputDate";
import OutputBoolean from "./type/OutputBoolean";
import OutputImage from "./type/OutputImage";
import OutputPointer from "./type/OutputPointer";

const outputComponents = {
    Email: OutputString,
    String: OutputString,
    Text: OutputString,
    Number: OutputString,
    Tel: OutputString,
    Enum: OutputString,
    Boolean: OutputBoolean,
    Date: OutputDate,
    Image: OutputImage,
    Pointer: OutputPointer,
};

function OutputFactory({type, _type, field, object, ...options}) {
    const Component = outputComponents[_type] || outputComponents[type]; // Check _type first, fallback to type
    if (Component) {
        return <Component
            field={field}
            object={object}
            {...options} />;
    }
    if (type === 'Component') {
        return object[field];
    }
    return null;
}

export default OutputFactory;
